import { css } from 'styled-components/macro';

export const containercss = css`
  width: 100%;
  display: flex;
  height: 483px;
  position: relative;
  flex-direction: row;
  justify-content: center;

  path {
    cursor: pointer;
  }
`;
